var regEmailController = {
    elForm: $('#regEmailForm'),
    elFormCode: $('#regEmailCodeForm'),
    regModalEmail: $('#regModalEmail'),
    regModalCode: $('#regModalEmailCode'),
    regModalSetPass: $('#regModalSetPass'),
    regModalFailed: $('#regModalEmailFailed'),
    email: '',
    init: function()
    {
        regEmailController.elForm.find('.error-text').hide();
        regEmailController.email = regEmailController.elForm.find('.js-input-email').val();

        regEmailController.elForm.find('.js-input-email').on('click change keyup blur input', function() {
            regEmailController.email = $(this).val().trim();
        });

        regEmailController.regModalCode.find('.js-send-again').click(function() {
            regEmailController.submitForm();

            return false;
        });

        regEmailController.elForm.find('button').on('click', function() {
            regEmailController.submitForm();

            return false;
        });

        regEmailController.regModalFailed.find('.js-return').click(function () {
            regEmailController.regModalEmail.modal('show');
            regEmailController.regModalFailed.modal('hide');
        });
    },
    submitForm: function()
    {
        if (!regEmailController.validateForm()) {
            regEmailController.showError();

            return false;
        }

        var emailCodeEnabled = (typeof AUTH_TYPE !== 'undefined' && AUTH_TYPE.EMAIL_CODE_ENABLED);
        var postData = regEmailController.elForm.serialize();

        if (!emailCodeEnabled) {
            postData += '&check_only=1';
        }

        $.post(
            regEmailController.elForm.attr('action'),
            postData,
            function(data) {
                if (data.success) {
                    if (emailCodeEnabled) {
                        regEmailController.regModalCode.modal('show');
                        regEmailController.regModalCode.find('.tip-text span').text(regEmailController.email);
                        regEmailController.regModalCode.find('.js-input-email').val(regEmailController.email);
                        regEmailController.regModalEmail.modal('hide');
                        authBaseController.startCountdown(
                            regEmailController.regModalCode.find('.js-countdown'),
                            regEmailController.regModalCode.find('.js-send-again')
                        );
                    } else {
                        regEmailController.regModalSetPass.modal('show');
                        regEmailController.regModalSetPass.find('.js-input-username').val(regEmailController.email);
                        regEmailController.regModalSetPass.find('.js-input-reg-by-email').val(1);
                        regEmailController.regModalSetPass.find('.js-input-reg-by-phone').val(0);
                        regEmailController.regModalEmail.modal('hide');
                    }
                } else {
                    if(data.message) {
                        regEmailController.regModalFailed.find('.text-top').text(data.message);
                        regEmailController.regModalFailed.modal('show');
                        regEmailController.regModalEmail.modal('hide');
                    }
                }
            }, 'json');
    },
    validateForm: function()
    {
        regEmailController.clearForm();
        var regex = /^([a-zA-Z0-9_.+-])+\@(([a-zA-Z0-9-])+\.)+([a-zA-Z0-9]{2,4})+$/;
        return (regEmailController.email.length > 3 && regex.test(regEmailController.email));
    },
    clearForm: function()
    {
        regEmailController.elForm.find('.form-group').removeClass('has-error');
        regEmailController.elForm.find('.error-text').hide();
    },
    showError: function()
    {
        regEmailController.elForm.find('.form-group').addClass('has-error');
        regEmailController.elForm.find('.error-text').show();
    }
};

$(function(){
    regEmailController.init();
});